<div class="upload-content">
  <div>
    <input
      type="file"
      hidden
      #fileDropRef
      (change)="handleFileSelect($event)"
    />

    <ng-container *ngIf="!uploadedFile">
      <i class="mdi mdi-cloud-upload"></i>
      <p>
        clique
        <button
          type="button"
          class="btn p-0 text-primary"
          (click)="fileDropRef.click()"
          [disabled]="readonly"
        >
          aqui para selecionar.
        </button>
        <small class="d-block">formatos validos: {{ getAllowedFormats }}</small>
      </p>
    </ng-container>

    <ng-container *ngIf="!!uploadedFile">
      <div class="drop-section">
        <div class="file-item">
          <img
            *ngIf="uploadedFile.isImageType"
            [src]="uploadedFile.url"
            [alt]="uploadedFile.name"
            class="uploaded-image"
          />

          <img
            *ngIf="uploadedFile.isPdfType"
            src="../../../../assets/images/pdf-logo.png"
            [alt]="uploadedFile.name"
            class="cv-document"
          />

          <!-- Exibir ícone genérico para outros tipos de arquivos -->
          <img
            *ngIf="uploadedFile.isGenericType"
            src="assets/images/file-icon.png"
            [alt]="uploadedFile.name"
            class="uploaded-icon"
          />

          <div class="btn-remover">
            <button
              *ngIf="preview"
              [disabled]="!uploadedFile.isImageType"
              class="btn btn-danger btn-sm"
              (click)="openPreviewModal()"
            >
              <span class="mdi mdi-eye-outline"></span>
            </button>

            <button class="btn btn-danger btn-sm" (click)="handleFileRemove()">
              <span class="mdi mdi-delete-outline"></span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Modal para exibir a imagem -->

    <app-new-modal
      [modalOpen]="showPreviewModal"
      (closeModalEvent)="closePreviewModal()"
    >
      <div class="pdf-content" (keydown)="onModalKeyDown($event)">
        <img
          [src]="uploadedFile?.url"
          [alt]="uploadedFile?.name"
          class="uploaded-image"
        />
      </div>
    </app-new-modal>
  </div>
</div>
